"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GlobalCustomElementProps {
    static getProps(key) {
        if (!window.__FMK_online_Custom_Element_Props__) {
            window.__FMK_online_Custom_Element_Props__ = {};
        }
        const propsMap = window.__FMK_online_Custom_Element_Props__;
        return propsMap[key];
    }
    static setProps(key, obj) {
        if (!window.__FMK_online_Custom_Element_Props__) {
            window.__FMK_online_Custom_Element_Props__ = {};
        }
        const propsMap = window.__FMK_online_Custom_Element_Props__;
        propsMap[key] = obj;
    }
}
exports.default = GlobalCustomElementProps;
//# sourceMappingURL=GlobalCustomElementProps.js.map